
export class PortalMenu {
  lDashBoardPortalMenuId: number;
  DashBoardPortalMenu: string;
  ParentName: string;
  lDashBoardPortalMenuParentId: number;
  QueryString: string;
  DisplayOrder: number;
  Enabled: boolean;
  dashBoardPortalMenuParentChildViews?: PortalMenu[];
  User: string;
  Image: string;
  IsStaticEntity: number;
  IsCustomMenu: number;
}

export class ChangePasswordUserAction
{
  OldPassword: string;
  NewPassword: string;  
}


export class IdentityServerSwitchValue
{
  switchValue: string;
  switchUriValue: string;
}
